<template>
<div class="oauth-setup">
    <!-- Don't chain with v-else-if, views are selectively hidden/shown
         I know it's confusing, sorry. -->
    <template v-if="requiresOAuthSetup && state !== $const.OAUTH_SUCCESS">
        <h3 class="subtitle is-3">Twitch Permissions</h3>
        <div class="request-permission">
            <p>
                Twitch requires this extension to honor chat bans and timeouts.
            </p>
            <p>
                Please grant me permission to access your channel's ban list.
            </p>
            <p>
                If you don't, new suggestions will not be visible.
            <p>
                This is a <b><u>required</u></b> permission.
            </p>
            <OAuthButton class="is-large" :oauthState.sync="state"/>
            <article class="message is-info is-small m-t-15">
                <div class="message-body">
                    <p>
                        If you see "status: 401" or "invalid csrf token",
                        try clearing your cookies for twitch.tv and all twitch.tv
                        subdomains (*.twitch.tv), including id.twitch.tv.
                    </p>
                    <p>
                        If that doesn't work, use another browser to grant
                        permission. For example, if you're on Chrome, try
                        granting permission in Firefox.
                    </p>
                </div>
            </article>
            <article
                v-if="didUserAlreadyGivePermission && state === $const.OAUTH_ASK_PERMISSION"
                class="message is-info is-small m-t-15">
                <div class="message-body">
                    If you already gave permission, that means
                    I added a feature that requires new permissions, or I
                    made a mistake. Please give me permission again, thanks.
                </div>
            </article>
        </div>
    </template>
    <article v-if="state === $const.OAUTH_DENIED" class="message is-danger">
        <div class="message-body with-emoji">
            <span class="icon is-large">
                <Emote :emote="'😑'" :size="40"/>
            </span>
            <p>
                You denied permission. Viewers won't be able to post suggestions.
            </p>
        </div>
    </article>
    <article v-if="state === $const.OAUTH_ERROR" class="message is-danger">
        <div class="message-header"><span>Error</span></div>
        <div class="message-body">
            <p>
                The error has been reported to my email, and
                I will investigate. Please try again.
            </p>
            <p>
                If this keeps happening, please contact me at guanzo91@gmail.com
                or contact Twitch.tv to resolve this issue.
            </p>
        </div>
    </article>
    <article v-if="state === $const.OAUTH_NO_ACTION" class="message is-warning">
        <div class="message-body with-emoji">
            <span class="icon is-large">
                <Emote :emote="'🤔'" :size="40"/>
            </span>
            <div>
                <div>
                    Hmm... you didn't give permission yet? If the popup is
                    slow to load, just wait. You can try closing and reopening
                    it, but that won't make it load any faster.
                </div>
            </div>
        </div>
    </article>
    <article v-if="state === $const.OAUTH_SUCCESS && showSuccessMsg" class="message is-success">
        <div class="message-header">
            <span>Thanks!</span>
            <button @click="showSuccessMsg = false" class="delete"/>
        </div>
        <div class="message-body">
            <div>Now you can configure Suggestion Box.</div>
        </div>
    </article>
</div>
</template>

<script>
import OAuthButton from '@/components/OAuthButton'
import * as C from '@shared/constants'
import ls from '@/local-storage'

export default {
    name: 'OAuthSetup',
    props: {
        requiresOAuthSetup: Boolean,
    },
    data: () => ({
        state: C.OAUTH_ASK_PERMISSION,
        showSuccessMsg: true,
        didUserAlreadyGivePermission: false,
    }),
    created () {
        const key = C.OAUTH_LOCAL_STORAGE_KEY
        this.didUserAlreadyGivePermission = !!ls.getItem(key)
    },
    components: {
        OAuthButton
    }
}
</script>

<style lang="scss" scoped>
.request-permission, .message {
    margin-bottom: 1rem;
}

.message.is-success {
    .message-body {
        display: flex;
        align-items: baseline;
        div {
            margin-right: 1rem;
        }
    }
}

.with-emoji {
    display: flex;
    align-items: center;
    .icon {
        margin-right: 1rem;
    }
}
</style>
